import React from 'react';
import { useForm } from 'react-hook-form';
import { withRouter } from 'react-router-dom';
import { useStateMachine } from 'little-state-machine';
import updateAction from './updateAction';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';

const Step2 = ({ history, isParent, childrenAge }) => {
	const { register, handleSubmit, watch, errors } = useForm();
	const revealChild = watch('isParent');

	const { state, action } = useStateMachine(updateAction);

	const onSubmit = (data) => {
		action(data);
		history.push('./step3');
	};
	let Child = childrenAge?.split(',') || state.data.Child || [0];

	const [indexes, setIndexes] = React.useState(
		Array.from(Array(Child?.length).keys()),
	);
	const [counter, setCounter] = React.useState(Child.length || 1);

	const addChild = () => {
		if (counter < 8) {
			setIndexes((prevIndexes) => [...prevIndexes, counter]);
			setCounter((prevCounter) => prevCounter + 1);
		}
	};

	const removeChild = (index) => () => {
		setIndexes((prevIndexes) => [
			...prevIndexes.filter((item) => item !== index),
		]);

		setCounter((prevCounter) => prevCounter - 1);
	};

	const clearChildren = () => {
		setIndexes([]);
		setCounter(0);
	};

	return (
		<Card>
			<Card.Header className="setup-content" id="step-2">
				<h3>Are you a parent?</h3>
			</Card.Header>
			<Card.Body>
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="funkyradio">
						<span className="profileError">
							{errors.isParent?.type === 'required' && 'Please fill out this field'}
						</span>
						<div className="funkyradio-success">
							<input
								type="radio"
								value={1}
								ref={register({
									required: true,
								})}
								name="isParent"
								id="radio1"
								defaultChecked={state?.data?.isParent === '1' || isParent === 1}
							/>
							<label for="radio1">Yes</label>
						</div>

						<div className="funkyradio-success">
							<input
								type="radio"
								value={0}
								ref={register({
									required: true,
								})}
								name="isParent"
								id="radio2"
								defaultChecked={state?.data?.isParent === '0' || isParent === 0}
							/>
							<label for="radio2">No</label>
						</div>
					</div>

					{revealChild === '1' ||
						(typeof revealChild === 'undefined' &&
							(state.data?.isParent === '1' || isParent === 1)) ? (
						<div className="form-group" style={{ marginTop: '10px' }}>
							{indexes.map((index, i) => {
								const fieldName = `Child[${index}]`;
								return (
									<div
										className="form-group has-float-label"
										name={fieldName}
										key={fieldName}
									>
										<input
											type="number"
											defaultValue={Child[index]?.age || Child[index]}
											name={`${fieldName}.age`}
											style={{ marginBottom: '15px' }}
											ref={register({
												min: 1,
												max: 17,
												pattern: /^[0-9]+$/i,
												required: true,
											})}
											className="form-control"
										/>
										<label>Child Age {i + 1}:</label>

										<span className="profileError">
											{errors.Child &&
												errors.Child[index]?.age?.type === 'min' &&
												'Child age should be at least 1'}
										</span>

										<span className="profileError">
											{errors.Child &&
												errors.Child[index]?.age?.type === 'max' &&
												'Child age should be less than 18'}
										</span>

										<span className="profileError">
											{errors.Child &&
												errors.Child[index]?.age?.type === 'pattern' &&
												'Age should be numeric'}
										</span>

										<span className="profileError">
											{errors.Child &&
												errors.Child[index]?.age?.type === 'required' &&
												'Please add age or remove field'}
										</span>
										<br />
										<button
											aria-label="remove"
											type="button"
											className="btn btn-info"
											onClick={removeChild(index)}
										>
											Remove
										</button>
									</div>
								);
							})}

							<button
								aria-label="add-child"
								type="button"
								className="btn btn-info"
								style={{
									marginRight: '15px',
									display: `${counter > 7 ? 'none' : 'inline-block'}`,
								}}
								onClick={addChild}
							>
								Add Child
							</button>
							<button
								aria-label="clear-child"
								type="button"
								className="btn btn-info"
								style={{ marginRight: '15px' }}
								onClick={clearChildren}
							>
								Clear Children
							</button>
						</div>
					) : null}
					<button
						aria-label="next"
						className="btn btn-primary nextBtn pull-right"
						type="submit"
					>
						Next
					</button>
				</form>
			</Card.Body>
		</Card>
	);
};

const mapStateToProps = (state) => {
	const { isParent, childrenAge } = state.rootReducer.profileDetails;
	return {
		isParent,
		childrenAge,
	};
};

export default compose(withRouter, connect(mapStateToProps))(Step2);
